import { Component, ChangeDetectorRef, OnInit } from "@angular/core";
import { ConnectionService } from "ng-connection-service";
import { SharedService } from './utils/services/shared.service';
import { SessionStorage } from 'ngx-webstorage';
import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  isConnected = true;
  status = "ONLINE";
  public loading = true;
  @SessionStorage('auth') public user;
  constructor(
    public router: Router,
    private connectionService: ConnectionService,
    private changeDetector: ChangeDetectorRef,
    private sharedService: SharedService,
    private actRoute: ActivatedRoute
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      this.changeDetector.detectChanges();
      if (this.isConnected) {
        this.status = "ONLINE";
      } else {
        this.status = "OFFLINE";
      }
    });
  }
  title = "amazon-ihs-webapp";
  ngOnInit() {
    // redirect to login if the token is not there
    // if (this.actRoute.snapshot.url.length == 0) {
    //   return;
    // }
    if (!this.user && this.actRoute.snapshot.url.length != 0) {
      this.router.navigateByUrl('/login');
    }
    this.sharedService.getDisplay().subscribe((val: boolean) => {
      this.loading = val;
      this.changeDetector.detectChanges();
    });
  }
}
